import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type {
  ApplyBatteryCreditHumanApplicationDto,
  BatteryCreditHumanApplicationHandoffDto,
} from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Apply for Credit Human financing from the exact current Quote. Retries with
 * the same idempotency key return the same attempt and handoff URL.
 */
export default function useApplyBatteryCreditHumanApplication(): UseMutationResult<
  BatteryCreditHumanApplicationHandoffDto,
  unknown,
  { proposalId: string; body: ApplyBatteryCreditHumanApplicationDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.applyCreditHumanApplication(proposalId, body),
    onSuccess: (handoff, { proposalId }) => {
      queryClient.setQueryData(
        queryKeys.batteryProposal.financing(proposalId),
        handoff.financing,
      )
    },
  })
}
